import ProductsIcon from "../assets/icons/products.svg";
import ProductsIconHover from "../assets/icons/productsHover.svg";
import GearIcon from "../assets/icons/gear.svg"
import GearIconHover from "../assets/icons/gearHover.svg"
import GroupProducts from "../views/ecommerce/group";
import Config from "../views/ecommerce/config";
import CartIcon from "../assets/icons/cart-shopping.svg";
import CartIconHover from "../assets/icons/cart-shoppingHover.svg";
import Products from "../views/ecommerce/products";

const routesEcommerce = [
    {
        id: "cm9a1",
        path: "/group-products",
        name: "Grupos de produtos",
        icon: ProductsIcon,
        iconHover: ProductsIconHover,
        layout: "/ecommerce",
        component: GroupProducts,
        redirect: false,
    },

    {
        id: "cm9a2",
        path: "/products-list",
        name: "Produtos",
        icon: CartIcon,
        iconHover: CartIconHover,
        layout: "/ecommerce",
        component: Products,
        redirect: false,
    },

    
    {
        id: "cm9a3",
        path: "/configurations",
        name: "Configurações",
        icon: GearIcon,
        iconHover: GearIconHover,
        layout: "/ecommerce",
        component: Config,
        redirect: false,
    }
]

export default routesEcommerce;